import { useState, useEffect } from "react";
import { auth } from "../config/firebaseConfig";
import { getApiUrl, getApiHeaders } from "../config/api";

export const useUserProfile = () => {
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [verified, setVerified] = useState(false);
  const [lastLogin, setLastLogin] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [providerData, setProviderData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      setLoading(true);
      const user = auth.currentUser;
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const idToken = await user.getIdToken();
        const res = await fetch(getApiUrl("api/me"), {
          headers: getApiHeaders({ Authorization: `Bearer ${idToken}` })
        });
        
        if (res.ok) {
          const data = await res.json();
          setDisplayName(data.display_name || "");
          setEmail(data.email || "");
          setPhotoURL(data.photo_url || "");
        } else {
          // Fallback to Firebase
          setDisplayName(user.displayName || "");
          setEmail(user.email || "");
          setPhotoURL(user.photoURL || "");
        }
        
        setVerified(user.emailVerified);
        setLastLogin(user.metadata?.lastSignInTime || "");
        setCreatedAt(user.metadata?.creationTime || "");
        setProviderData(user.providerData || []);
      } catch (error) {
        // Fallback to Firebase on error
        setDisplayName(user.displayName || "");
        setEmail(user.email || "");
        setPhotoURL(user.photoURL || "");
        setVerified(user.emailVerified);
        setLastLogin(user.metadata?.lastSignInTime || "");
        setCreatedAt(user.metadata?.creationTime || "");
        setProviderData(user.providerData || []);
      }
      
      setLoading(false);
    };

    // Listen to auth state changes
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        fetchUserProfile();
      } else {
        setDisplayName("");
        setEmail("");
        setPhotoURL("");
        setVerified(false);
        setLastLogin("");
        setCreatedAt("");
        setProviderData([]);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return {
    displayName,
    email,
    photoURL,
    verified,
    lastLogin,
    createdAt,
    providerData,
    loading,
    firstName: displayName.trim().split(" ")[0] || "User"
  };
};
